window.SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME = "selected_option_background";
window.UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME = "unselected_option_background";
window.CHECKBOX_AND_RADIO_OPTIONS_PARENT_WRAPPER_CLASSNAME = "form-check-inline";